import { render, staticRenderFns } from "./EditTravelPolicy.vue?vue&type=template&id=100f9bd3&scoped=true"
import script from "./EditTravelPolicy.vue?vue&type=script&lang=js"
export * from "./EditTravelPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100f9bd3",
  null
  
)

export default component.exports